import { getCurrentStoreConfig, getStoreConfig } from "@app/config";
import Alpine from "alpinejs";

Alpine.magic('storeConfig', () => {
    const config = getCurrentStoreConfig()
    return config
})
